import { map } from "lodash";
import { dHearAboutUs, dRepCategories } from "tmt_api/src/shared/dics";
import type {
  tAvailability,
  tBrandCategory,
  tBrandPressPublication,
  tIndependentRetailerQuantity,
  tPrice,
  tRepBrandQuantity,
  tRepCategory,
  tRetailerCategory,
  tRetailLocationQuantity,
} from "tmt_api/src/types/types.validator";
import { tOption } from "../components/ComboBox";

export type tCountryCodes = "US" | "GB" | "CA" | "DE" | "FR" | "ES" | "AU" | "SE";

export type tCountryOption = { label: string; value: tCountryCodes };

export const aBrandCategories: Array<tOption<tBrandCategory>> = [
  { myLabel: "Home Decor", myValue: "HomeDecor" },
  { myLabel: "Lifestyle & Gift", myValue: "Lifestyle" },
  { myLabel: "Skincare & Beauty", myValue: "Beauty" },
  { myLabel: "Gourmet", myValue: "Gourmet" },
  { myLabel: "Accessories", myValue: "Accessories" },
  { myLabel: "Wellness", myValue: "Wellness" },
  { myLabel: "Other", myValue: "Other" },
];

export const aShippingLeadTime: Array<tOption<string>> = [
  { myValue: "1-3 Days", isDefault: true },
  { myValue: "4-7 Days" },
  { myValue: "8-10 Days" },
  { myValue: "11-14 Days" },
  { myValue: "15-20 Days" },
  { myValue: "25+ Days" },
];
export const aPriceRange: Array<tOption<tPrice>> = [
  { myValue: "$" },
  { myValue: "$$" },
  { myValue: "$$$" },
  { myValue: "$$$$" },
];

export const aBrandStoreCount: Array<tOption<tIndependentRetailerQuantity>> = [
  { myValue: "<50" },
  { myValue: "50-150" },
  { myValue: "200+" },
];

export type tpRepType = "Select Rep Type" | "Independent Sales Rep" | "Sales Rep Agency";

export const aRepType: Array<tOption<tpRepType>> = [
  { myValue: "Select Rep Type", isDefault: true },
  { myValue: "Independent Sales Rep" },
  { myValue: "Sales Rep Agency" },
];

export const aRepBrandCount: Array<tOption<tRepBrandQuantity>> = [
  { myValue: "1-5" },
  { myValue: "5-10" },
  { myValue: "10-15" },
  { myValue: "15+" },
];

export const aRepBrandCategories: Array<tOption<tRepCategory>> = [
  { myLabel: "Beauty & skin", myValue: "Beauty" },
  { myLabel: "Home Decor", myValue: "HomeDecor" },
  { myLabel: "Interior Design", myValue: "InteriorDesign" },
  { myLabel: "Apparel & Accessories", myValue: "Accessories" },
  { myLabel: "Fitness & Wellness", myValue: "Wellness" },
  { myLabel: "Publishing", myValue: "Publishing" },
  { myLabel: "Gist & Tabletop", myValue: "Gift" },
  { myLabel: "Gourmet", myValue: "Gourmet" },
  { myLabel: "General", myValue: "General" },
];

export const aRetailCategories: Array<tOption<tRetailerCategory>> = [
  { myLabel: "Gift Shop", myValue: "GiftShop" },
  { myLabel: "Interior Design", myValue: "InteriorDesign" },
  { myLabel: "Apothecary", myValue: "Apothecary" },
  { myLabel: "Home Decor Store", myValue: "HomeDecor" },
  { myLabel: "Fitness/Wellness Store", myValue: "Fitness" },
  { myLabel: "Fashion Boutique", myValue: "Fashion" },
  { myLabel: "Spa or Salon Store", myValue: "Spa" },
  { myLabel: "Kids Store", myValue: "Kids" },
  { myLabel: "Bookstore", myValue: "Bookstore" },
  { myLabel: "Gourmet", myValue: "Gourmet" },
  { myLabel: "General Store", myValue: "General" },
  { myLabel: "Stationary Store", myValue: "Stationary" },
  { myLabel: "Hotel/Hospitality Store", myValue: "Hospitality" },
  { myLabel: "Botanical Store", myValue: "Botanical" },
  { myLabel: "Subscription Box", myValue: "SubscriptionBox" },
  { myLabel: "E-commerce", myValue: "ECommerce" },
  { myLabel: "Men's", myValue: "Men" },
  { myLabel: "Pet Store", myValue: "Pet" },
  { myLabel: "International", myValue: "International" },
  { myLabel: "Other", myValue: "Other" },
];

export const aVariantOptions: Array<tOption<string>> = [
  { myValue: "Size" },
  { myValue: "Color" },
  { myValue: "Material" },
  { myValue: "Style" },
  { myValue: "Sent" },
];

export const aVariantUnits: Array<tOption<string>> = [{ myValue: "oz" }, { myValue: "gm" }, { myValue: "lb" }];

export const aAvailabilityOptions: Array<tOption<tAvailability>> = [
  { myLabel: "Publish", myValue: "available" },
  { myLabel: "Unpublish", myValue: "unavailable" },
];

export const aRetailStoreCount: Array<tOption<tRetailLocationQuantity>> = [
  { myValue: "0-1" },
  { myValue: "1-3" },
  { myValue: "3+" },
];

export const aStates: Array<tOption<string>> = [
  { myLabel: "State", myValue: "state" },
  { myLabel: "Alabama", myValue: "AL" },
  { myLabel: "Alaska", myValue: "AK" },
  { myLabel: "Arizona", myValue: "AZ" },
  { myLabel: "Arkansas", myValue: "AR" },
  { myLabel: "California", myValue: "CA" },
  // { myLabel: "Canal Zone", myValue: "CZ" },
  { myLabel: "Colorado", myValue: "CO" },
  { myLabel: "Connecticut", myValue: "CT" },
  { myLabel: "Delaware", myValue: "DE" },
  { myLabel: "District of Columbia", myValue: "DC" },
  { myLabel: "Florida", myValue: "FL" },
  { myLabel: "Georgia", myValue: "GA" },
  // { myLabel: "Guam", myValue: "GU" },
  { myLabel: "Hawaii", myValue: "HI" },
  { myLabel: "Idaho", myValue: "ID" },
  { myLabel: "Illinois", myValue: "IL" },
  { myLabel: "Indiana", myValue: "IN" },
  { myLabel: "Iowa", myValue: "IA" },
  { myLabel: "Kansas", myValue: "KS" },
  { myLabel: "Kentucky", myValue: "KY" },
  { myLabel: "Louisiana", myValue: "LA" },
  { myLabel: "Maine", myValue: "ME" },
  { myLabel: "Maryland", myValue: "MD" },
  { myLabel: "Massachusetts", myValue: "MA" },
  { myLabel: "Michigan", myValue: "MI" },
  { myLabel: "Minnesota", myValue: "MN" },
  { myLabel: "Mississippi", myValue: "MS" },
  { myLabel: "Missouri", myValue: "MO" },
  { myLabel: "Montana", myValue: "MT" },
  { myLabel: "Nebraska", myValue: "NE" },
  { myLabel: "Nevada", myValue: "NV" },
  { myLabel: "New Hampshire", myValue: "NH" },
  { myLabel: "New Jersey", myValue: "NJ" },
  { myLabel: "New Mexico", myValue: "NM" },
  { myLabel: "New York", myValue: "NY" },
  { myLabel: "North Carolina", myValue: "NC" },
  { myLabel: "North Dakota", myValue: "ND" },
  { myLabel: "Ohio", myValue: "OH" },
  { myLabel: "Oklahoma", myValue: "OK" },
  { myLabel: "Oregon", myValue: "OR" },
  { myLabel: "Pennsylvania", myValue: "PA" },
  // { myLabel: "Puerto Rico", myValue: "PR" },
  { myLabel: "Rhode Island", myValue: "RI" },
  { myLabel: "South Carolina", myValue: "SC" },
  { myLabel: "South Dakota", myValue: "SD" },
  { myLabel: "Tennessee", myValue: "TN" },
  { myLabel: "Texas", myValue: "TX" },
  { myLabel: "Utah", myValue: "UT" },
  { myLabel: "Vermont", myValue: "VT" },
  // { myLabel: "Virgin Islands", myValue: "VI" },
  { myLabel: "Virginia", myValue: "VA" },
  { myLabel: "Washington", myValue: "WA" },
  { myLabel: "West Virginia", myValue: "WV" },
  { myLabel: "Wisconsin", myValue: "WI" },
  { myLabel: "Wyoming", myValue: "WY" },
];

export const aCountries: Array<tOption<string>> = [
  { myLabel: "Afghanistan", myValue: "AF" },
  { myLabel: "Albania", myValue: "AL" },
  { myLabel: "Algeria", myValue: "DZ" },
  { myLabel: "Andorra", myValue: "AD" },
  { myLabel: "Angola", myValue: "AO" },
  { myLabel: "Antigua and Barbuda", myValue: "AG" },
  { myLabel: "Argentina", myValue: "AR" },
  { myLabel: "Armenia", myValue: "AM" },
  { myLabel: "Australia", myValue: "UA" },
  { myLabel: "Austria", myValue: "AT" },
  { myLabel: "Azerbaijan", myValue: "AZ" },
  { myLabel: "The Bahamas", myValue: "BS" },
  { myLabel: "Bahrain", myValue: "BH" },
  { myLabel: "Bangladesh", myValue: "BD" },
  { myLabel: "Barbados", myValue: "BB" },
  { myLabel: "Belarus", myValue: "BY" },
  { myLabel: "Belgium", myValue: "BE" },
  { myLabel: "Belize", myValue: "BZ" },
  { myLabel: "Benin", myValue: "BJ" },
  { myLabel: "Bhutan", myValue: "BT" },
  { myLabel: "Bolivia", myValue: "BO" },
  { myLabel: "Bosnia and Herzegovina", myValue: "BA" },
  { myLabel: "Botswana", myValue: "BW" },
  { myLabel: "Brazil", myValue: "BR" },
  { myLabel: "Brunei", myValue: "BN" },
  { myLabel: "Bulgaria", myValue: "BG" },
  { myLabel: "Burkina Faso", myValue: "BF" },
  { myLabel: "Burundi", myValue: "BI" },
  { myLabel: "Cambodia", myValue: "KH" },
  { myLabel: "Cameroon", myValue: "CM" },
  { myLabel: "Canada", myValue: "CA" },
  { myLabel: "Cape Verde", myValue: "CV" },
  { myLabel: "Central African Republic", myValue: "CF" },
  { myLabel: "Chad", myValue: "TD" },
  { myLabel: "Chile", myValue: "CL" },
  { myLabel: "China", myValue: "CN" },
  { myLabel: "Colombia", myValue: "CO" },
  { myLabel: "Comoros", myValue: "KM" },
  { myLabel: "Congo", myValue: "CG" },
  { myLabel: "Congo, Democratic Republic of the", myValue: "CD" },
  { myLabel: "Costa Rica", myValue: "CR" },
  { myLabel: "Cote d'Ivoire", myValue: "CI" },
  { myLabel: "Croatia", myValue: "HR" },
  { myLabel: "Cuba", myValue: "CU" },
  { myLabel: "Cyprus", myValue: "CY" },
  { myLabel: "Czech Republic", myValue: "CZ" },
  { myLabel: "Denmark", myValue: "DK" },
  { myLabel: "Djibouti", myValue: "DJ" },
  { myLabel: "Dominica", myValue: "DM" },
  { myLabel: "Dominican Republic", myValue: "DO" },
  // { myLabel: "East Timor (Timor-Leste)", myValue: "" },
  { myLabel: "Ecuador", myValue: "EC" },
  { myLabel: "Egypt", myValue: "EG" },
  { myLabel: "El Salvador", myValue: "SV" },
  { myLabel: "Equatorial Guinea", myValue: "GQ" },
  { myLabel: "Eritrea", myValue: "ER" },
  { myLabel: "Estonia", myValue: "EE" },
  { myLabel: "Ethiopia", myValue: "ET" },
  { myLabel: "Fiji", myValue: "FJ" },
  { myLabel: "Finland", myValue: "FI" },
  { myLabel: "France", myValue: "FR" },
  { myLabel: "Gabon", myValue: "GA" },
  { myLabel: "Gambia", myValue: "GM" },
  { myLabel: "Georgia", myValue: "GE" },
  { myLabel: "Germany", myValue: "DE" },
  { myLabel: "Ghana", myValue: "GH" },
  { myLabel: "Greece", myValue: "GR" },
  { myLabel: "Grenada", myValue: "GD" },
  { myLabel: "Guatemala", myValue: "GT" },
  { myLabel: "Guinea", myValue: "GN" },
  { myLabel: "Guinea-Bissau", myValue: "GW" },
  { myLabel: "Guyana", myValue: "GY" },
  { myLabel: "Haiti", myValue: "HT" },
  { myLabel: "Honduras", myValue: "HN" },
  { myLabel: "Hungary", myValue: "HU" },
  { myLabel: "Iceland", myValue: "IS" },
  { myLabel: "India", myValue: "IN" },
  { myLabel: "Indonesia", myValue: "ID" },
  { myLabel: "Iran", myValue: "IR" },
  { myLabel: "Iraq", myValue: "IQ" },
  { myLabel: "Ireland", myValue: "IE" },
  { myLabel: "Israel", myValue: "IL" },
  { myLabel: "Italy", myValue: "IT" },
  { myLabel: "Jamaica", myValue: "JM" },
  { myLabel: "Japan", myValue: "JP" },
  { myLabel: "Jordan", myValue: "JO" },
  { myLabel: "Kazakhstan", myValue: "KZ" },
  { myLabel: "Kenya", myValue: "KE" },
  { myLabel: "Kiribati", myValue: "KI" },
  { myLabel: "Korea, North", myValue: "KP" },
  { myLabel: "Korea, South", myValue: "KR" },
  // { myLabel: "Kosovo", myValue: "MS" },
  { myLabel: "Kuwait", myValue: "KW" },
  { myLabel: "Kyrgyzstan", myValue: "KG" },
  { myLabel: "Laos", myValue: "LA" },
  { myLabel: "Latvia", myValue: "LV" },
  { myLabel: "Lebanon", myValue: "LB" },
  { myLabel: "Lesotho", myValue: "LS" },
  { myLabel: "Liberia", myValue: "LR" },
  { myLabel: "Libya", myValue: "LY" },
  { myLabel: "Liechtenstein", myValue: "LI" },
  { myLabel: "Lithuania", myValue: "LT" },
  { myLabel: "Luxembourg", myValue: "LU" },
  { myLabel: "Macedonia", myValue: "MK" },
  { myLabel: "Madagascar", myValue: "MG" },
  { myLabel: "Malawi", myValue: "MW" },
  { myLabel: "Malaysia", myValue: "MY" },
  { myLabel: "Maldives", myValue: "MV" },
  { myLabel: "Mali", myValue: "ML" },
  { myLabel: "Malta", myValue: "MT" },
  { myLabel: "Marshall Islands", myValue: "MH" },
  { myLabel: "Mauritania", myValue: "MR" },
  { myLabel: "Mauritius", myValue: "MU" },
  { myLabel: "Mexico", myValue: "MX" },
  { myLabel: "Micronesia, Federated States of", myValue: "FM" },
  { myLabel: "Moldova", myValue: "MD" },
  { myLabel: "Monaco", myValue: "MC" },
  { myLabel: "Mongolia", myValue: "MN" },
  { myLabel: "Montenegro", myValue: "ME" },
  { myLabel: "Morocco", myValue: "MA" },
  { myLabel: "Mozambique", myValue: "MZ" },
  { myLabel: "Myanmar", myValue: "MM" },
  { myLabel: "Namibia", myValue: "NM" },
  { myLabel: "Nauru", myValue: "NR" },
  { myLabel: "Nepal", myValue: "NP" },
  { myLabel: "Netherlands", myValue: "NL" },
  { myLabel: "New Zealand", myValue: "NZ" },
  { myLabel: "Nicaragua", myValue: "NI" },
  { myLabel: "Niger", myValue: "NE" },
  { myLabel: "Nigeria", myValue: "NG" },
  { myLabel: "Norway", myValue: "NO" },
  { myLabel: "Oman", myValue: "OM" },
  { myLabel: "Pakistan", myValue: "PK" },
  { myLabel: "Palau", myValue: "PW" },
  { myLabel: "Panama", myValue: "PA" },
  { myLabel: "Papua New Guinea", myValue: "PG" },
  { myLabel: "Paraguay", myValue: "PY" },
  { myLabel: "Peru", myValue: "PE" },
  { myLabel: "Philippines", myValue: "PH" },
  { myLabel: "Poland", myValue: "PL" },
  { myLabel: "Portugal", myValue: "PT" },
  { myLabel: "Qatar", myValue: "QA" },
  { myLabel: "Romania", myValue: "RO" },
  { myLabel: "Russia", myValue: "RU" },
  { myLabel: "Rwanda", myValue: "RW" },
  { myLabel: "Saint Kitts and Nevis", myValue: "KN" },
  { myLabel: "Saint Lucia", myValue: "LC" },
  { myLabel: "Saint Vincent and the Grenadines", myValue: "VC" },
  { myLabel: "Samoa", myValue: "WS" },
  { myLabel: "San Marino", myValue: "SM" },
  { myLabel: "Sao Tome and Principe", myValue: "ST" },
  { myLabel: "Saudi Arabia", myValue: "SA" },
  { myLabel: "Senegal", myValue: "SN" },
  { myLabel: "Serbia", myValue: "RS" },
  { myLabel: "Seychelles", myValue: "SC" },
  { myLabel: "Sierra Leone", myValue: "SL" },
  { myLabel: "Singapore", myValue: "SG" },
  { myLabel: "Slovakia", myValue: "SK" },
  { myLabel: "Slovenia", myValue: "SI" },
  { myLabel: "Solomon Islands", myValue: "SB" },
  { myLabel: "Somalia", myValue: "SO" },
  { myLabel: "South Africa", myValue: "ZA" },
  { myLabel: "South Sudan", myValue: "SS" },
  { myLabel: "Spain", myValue: "ES" },
  { myLabel: "Sri Lanka", myValue: "LK" },
  { myLabel: "Sudan", myValue: "SD" },
  { myLabel: "Suriname", myValue: "SR" },
  { myLabel: "Swaziland", myValue: "SSZ" },
  { myLabel: "Sweden", myValue: "SE" },
  { myLabel: "Switzerland", myValue: "SZ" },
  { myLabel: "Syria", myValue: "SY" },
  { myLabel: "Taiwan", myValue: "TW" },
  { myLabel: "Tajikistan", myValue: "TJ" },
  { myLabel: "Tanzania", myValue: "TZ" },
  { myLabel: "Thailand", myValue: "TH" },
  { myLabel: "Togo", myValue: "TG" },
  { myLabel: "Tonga", myValue: "TO" },
  { myLabel: "Trinidad and Tobago", myValue: "TT" },
  { myLabel: "Tunisia", myValue: "TN" },
  { myLabel: "Turkey", myValue: "TR" },
  { myLabel: "Turkmenistan", myValue: "TM" },
  { myLabel: "Tuvalu", myValue: "TV" },
  { myLabel: "Uganda", myValue: "UG" },
  { myLabel: "Ukraine", myValue: "UA" },
  { myLabel: "United Arab Emirates", myValue: "AE" },
  { myLabel: "United Kingdom", myValue: "GB" },
  { myLabel: "United States", myValue: "US" },
  { myLabel: "Uruguay", myValue: "UY" },
  { myLabel: "Uzbekistan", myValue: "UZ" },
  { myLabel: "Vanuatu", myValue: "VU" },
  // { myLabel: "Vatican City", myValue: "MN" },
  { myLabel: "Venezuela", myValue: "VE" },
  { myLabel: "Vietnam", myValue: "VN" },
  { myLabel: "Yemen", myValue: "YE" },
  { myLabel: "Zambia", myValue: "ZM" },
  { myLabel: "Zimbabwe", myValue: "ZW" },
];

export const usStateOptions = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  // { label: "Canal Zone", value: "CZ" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  // { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  // { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  // { label: "Virgin Islands", value: "VI" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
  { label: "None", value: "" },
];

export const caProvinceOptions = [
  { label: "Alberta", value: "AB" },
  { label: "New Brunswick	", value: "NB" },
  { label: "British Columbia", value: "BC" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Manitoba", value: "MB" },
  { label: "Quebec", value: "QC" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Yukon", value: "YT" },
  { label: "Nunavut", value: "NU" },
  { label: "Ontario", value: "ON" },
];

export const legacyCountriesOptions = [
  { label: "Afghanistan", value: "AF" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Australia", value: "UA" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "The Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Brazil", value: "BR" },
  { label: "Brunei", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Cape Verde", value: "CV" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo", value: "CG" },
  { label: "Congo, Democratic Republic of the", value: "CD" },
  { label: "Costa Rica", value: "CR" },
  { label: "Cote d'Ivoire", value: "CI" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  // { label: "East Timor (Timor-Leste)", value: "" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Ethiopia", value: "ET" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Greece", value: "GR" },
  { label: "Grenada", value: "GD" },
  { label: "Guatemala", value: "GT" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Honduras", value: "HN" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Korea, North", value: "KP" },
  { label: "Korea, South", value: "KR" },
  // { label: "Kosovo", value: "MS" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Laos", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Macedonia", value: "MK" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia, Federated States of", value: "FM" },
  { label: "Moldova", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NM" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Qatar", value: "QA" },
  { label: "Romania", value: "RO" },
  { label: "Russia", value: "RU" },
  { label: "Rwanda", value: "RW" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Sudan", value: "SS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Suriname", value: "SR" },
  { label: "Swaziland", value: "SSZ" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "SZ" },
  { label: "Syria", value: "SY" },
  { label: "Taiwan", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Togo", value: "TG" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UKR" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  // { label: "Vatican City", value: "MN" },
  { label: "Venezuela", value: "VE" },
  { label: "Vietnam", value: "VN" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];

export const reportTypes = [
  { label: "Total Sales", value: "total-sales" },
  { label: "Sales By SKU", value: "sales-by-sku" },
  { label: "Sales Reps", value: "sales-reps" },
  { label: "Brands", value: "brands" },
  { label: "Retailers", value: "retailers" },
  { label: "Connections", value: "connections" },
  { label: "Brand Invites", value: "brand-invites" },
  { label: "New Products", value: "new-products" },
  { label: "Inventory Status", value: "products-inventory" },
  { label: "Abandoned Carts", value: "abandoned-carts" },
  { label: "Promotions", value: "promotions" },
  { label: "Old Promotions", value: "old-promotions" },
];

export const orderStatusOptions = [
  { value: "All", label: "All" },
  { value: "Shipped", label: "Shipped" },
  { value: "Awaiting Fulfillment", label: "Awaiting Fulfillment" },
  { value: "Pending", label: "Pending" },
  { value: "Cancelled", label: "Cancelled" },
  { value: "Declined", label: "Declined" },
];

export const reportDateRanges = [
  { label: "All Time", value: "All Time" },
  { label: "Last 30 Days", value: "Last 30 Days" },
  { label: "Last 60 Days", value: "Last 60 Days" },
  { label: "Custom", value: "Custom" },
];

export const brandCategoryOptions: { label: string; value: tBrandCategory }[] = [
  { label: "Home Decor", value: "HomeDecor" },
  { label: "Lifestyle & Gift", value: "Lifestyle" },
  { label: "Skincare & Beauty", value: "Beauty" },
  { label: "Gourmet", value: "Gourmet" },
  { label: "Accessories", value: "Accessories" },
  { label: "Wellness", value: "Wellness" },
  { label: "Other", value: "Other" },
];

export const retailerCategoryOptions: { label: string; value: tRetailerCategory }[] = [
  { label: "Gift Shop", value: "GiftShop" },
  { label: "Interior Design", value: "InteriorDesign" },
  { label: "Apothecary", value: "Apothecary" },
  { label: "Home Decor Store", value: "HomeDecor" },
  { label: "Fitness/Wellness Store", value: "Fitness" },
  { label: "Fashion Boutique", value: "Fashion" },
  { label: "Spa or Salon Store", value: "Spa" },
  { label: "Kids Store", value: "Kids" },
  { label: "Bookstore", value: "Bookstore" },
  { label: "Gourmet", value: "Gourmet" },
  { label: "General Store", value: "General" },
  { label: "Stationary Store", value: "Stationary" },
  { label: "Hotel/Hospitality Store", value: "Hospitality" },
  { label: "Botanical Store", value: "Botanical" },
  { label: "Subscription Box", value: "SubscriptionBox" },
  { label: "E-commerce", value: "ECommerce" },
  { label: "Men's", value: "Men" },
  { label: "Pet Store", value: "Pet" },
  { label: "International", value: "International" },
  { label: "Other", value: "Other" },
];

export const retailerPricePointOptions: { label: string; value: tPrice }[] = [
  { label: "$", value: "$" },
  { label: "$$", value: "$$" },
  { label: "$$$", value: "$$$" },
  { label: "$$$$", value: "$$$$" },
];

export const retailerLocationQuantityOptions: { label: string; value: tRetailLocationQuantity }[] = [
  { label: "0-1", value: "0-1" },
  { label: "1-3", value: "1-3" },
  { label: "3+", value: "3+" },
];

export const hearAboutUsOptions: tOption<string>[] = map(dHearAboutUs, (value, key) => ({
  myValue: key,
  myLabel: value,
}));

export const repCategories: { label: string; value: string }[] = map(dRepCategories, (label, value) => ({
  label,
  value,
}));

export const countryUSOption: tCountryOption = { label: "United States", value: "US" };

export const countriesOptions: tCountryOption[] = [
  countryUSOption,
  { label: "United Kingdom", value: "GB" },
  // { label: "Mexico", value: "MX" },
  { label: "Canada", value: "CA" },
  { label: "Germany", value: "DE" },
  // { label: "Indonesia", value: "ID" },
  { label: "France", value: "FR" },
  { label: "Spain", value: "ES" },
  // { label: "Saudi Arabia", value: "SA" },
  // { label: "South Korea", value: "KR" },
  // { label: "United Arab Emirates", value: "AE" },
  // { label: "Ireland", value: "IE" },
  // { label: "Finland", value: "FI" },
  { label: "Australia", value: "AU" },
  // { label: "Denmark", value: "DK" },
  { label: "Sweden", value: "SE" },
];

export const brandEthosOptions: { label: string; value: string }[] = [
  { label: "Award Winning", value: "awardWinning" },
  { label: "Made In America", value: "madeInAmerica" },
  { label: "Eco Friendly", value: "ecoFriendly" },
  { label: "Small Batch", value: "smallBatch" },
  { label: "Organic", value: "organic" },
  { label: "Not On Amazon", value: "notOnAmazon" },
  { label: "Woman Owned", value: "womanOwned" },
  { label: "Sustainable", value: "sustainable" },
  { label: "Minority Owned", value: "minorityOwned" },
];

export const shippingLeadTimeOptions: { label: string; value: string }[] = [
  { label: "1-3 Days", value: "1-3 Days" },
  { label: "4-7 Days", value: "4-7 Days" },
  { label: "8-10 Days", value: "8-10 Days" },
  { label: "11-14 Days", value: "11-14 Days" },
  { label: "15-20 Days", value: "15-20 Days" },
  { label: "25+ Days", value: "25+ Days" },
];

export const pressPublicationOptions: { label: string; value: tBrandPressPublication }[] = [
  { label: "Allure", value: "Allure" },
  { label: "Beauty Independent", value: "Beauty Independent" },
  { label: "Bon Appetit", value: "Bon Appetit" },
  { label: "Bustle", value: "Bustle" },
  { label: "Byrdie", value: "Byrdie" },
  { label: "Cosmopolitan", value: "Cosmopolitan" },
  { label: "Coveteur", value: "Coveteur" },
  { label: "Elle", value: "Elle" },
  { label: "Essence", value: "Essence" },
  { label: "Forbes", value: "Forbes" },
  { label: "Glamour", value: "Glamour" },
  { label: "Glossy", value: "Glossy" },
  { label: "Goop", value: "Goop" },
  { label: "GQ", value: "GQ" },
  { label: "Harpers Bazaar", value: "Harpers Bazaar" },
  { label: "InStyle", value: "InStyle" },
  { label: "Into the Gloss", value: "Into the Gloss" },
  { label: "Marie Claire", value: "Marie Claire" },
  { label: "Martha Stewart", value: "Martha Stewart" },
  { label: "Medium", value: "Medium" },
  { label: "Modern Retail", value: "Modern Retail" },
  { label: "New Beauty", value: "New Beauty" },
  { label: "New York Post", value: "New York Post" },
  { label: "Oprah Daily", value: "Oprah Daily" },
  { label: "People", value: "People" },
  { label: "Retail Brew", value: "Retail Brew" },
  { label: "Refinery29", value: "Refinery29" },
  { label: "Self", value: "Self" },
  { label: "Southern Living", value: "Southern Living" },
  { label: "The Business of Fashion", value: "The Business of Fashion" },
  { label: "The Cut", value: "The Cut" },
  { label: "The New York Times", value: "The New York Times" },
  { label: "The Washington Post", value: "The Washington Post" },
  { label: "The Zoe Report", value: "The Zoe Report" },
  { label: "Town & Country", value: "Town & Country" },
  { label: "US Weekly", value: "US Weekly" },
  { label: "Vanity Fair", value: "Vanity Fair" },
  { label: "Vogue", value: "Vogue" },
  { label: "Who What Wear", value: "Who What Wear" },
  { label: "Well Good", value: "Well Good" },
  { label: "Women's Health", value: "Women's Health" },
  { label: "WWD", value: "WWD" },
];
